export default __webpack_public_path__ + "assets/c0745e29157827d3c3f5b796eeabe2f3.svg";